import React from 'react';
import { Link } from 'react-router-dom';

// Services & Helpers
import TextHelpers from 'helpers/TextHelpers';

// Images
import silhouetteImage from 'images/silhouette.png';
import subAgencySilhouetteImage from 'images/sub-agency-silhouette.png';

class InstructorList extends React.Component {
    
    constructor(props) {
        super(props);
    }

    render() {
        const { instructors, onClick, showSubAgency, onClickSubAgency } = this.props;
        if (!instructors) return null;
        
        return (
            <ul className="thing-list">
                {instructors.map(instructor =>
                    <li key={instructor.id} >
                        
                        <Link
                            to={`/instructor/${instructor.slug}`}
                            className={`instructor instructor-status-${(instructor.activeStatus || '').toLowerCase()}`}
                            onClick={e => onClick ? onClick(instructor, e) : null}
                        >
                            <div className="profile-image" style={{
                                backgroundImage: (
                                    instructor.photoVersion ? `url(/api/instructor/get-photo/${instructor.id}?size=small&version=${instructor.photoVersion})` :
                                        `url(${silhouetteImage})`
                                )
                            }} />

                            <div className="details">
                                <h3>
                                    {TextHelpers.formatInstructorName(instructor)}
                                    <div className="tags">
                                        {TextHelpers.getInstructorTags(instructor)}
                                    </div>
                                </h3>
                                <p className="detail">
                                    <span className="instructor-location">
                                        {[instructor.city?.name, instructor.country?.name].filter(a => !!a).join(', ')}
                                    </span>
                                    <span className="instructor-geos">
                                        ({instructor.geos.map((geo, index) =>
                                            <React.Fragment key={index}>
                                                {index != 0 && ', '}
                                                {geo.isPrimary ? <b>{geo.name}</b> : geo.name}
                                            </React.Fragment>)
                                        })
                                    </span>
                                </p>
                            </div>

                            {showSubAgency && instructor.subAgency &&
                                <div className="instructor-sub-agency" onClick={e => {
                                    if (onClickSubAgency) {
                                        onClickSubAgency(instructor.subAgency);
                                        e.preventDefault();
                                        e.stopPropagation();
                                    }
                                }}>
                                    <div className="profile-image" title={instructor.subAgency.name} style={{
                                        backgroundImage: (
                                            instructor.subAgency.photoVersion ? `url(/api/sub-agency/get-photo/${instructor.subAgency.id}?size=small&version=${instructor.subAgency.photoVersion})` :
                                                `url(${subAgencySilhouetteImage})`
                                        )
                                    }} />
                                </div>
                            }

                        </Link>

                    </li>
                )}
            </ul>
        );
    }
}

export default InstructorList;